<div class="history-mobile">
    <div class="app__mobile-page page-wrapper">
        <div *ngIf="loadingRnumbList" class="loading">
            <loader type="page" [isFullscreen]="true" message="Загружаем..."></loader>
        </div>
        <div class="header">
            <div class="header__tabs" [class.complited]="statusTab === 1">
                <div class="tab-slider">
                    <button
                        class="header__tab button__left"
                        [class.active]="statusTab === 0"
                        (click)="changeTab(0)"
                    >
                        Предстоящие
                    </button>
                    <button
                        class="header__tab button__right"
                        [class.active]="statusTab === 1"
                        (click)="changeTab(1)"
                    >
                        Завершенные
                    </button>
                    <div
                        class="tab-slider__indicator"
                        [style.transform]="getSliderPosition()"
                    ></div>
                </div>
                <button
                    class="mobile-filter__button {{ mobileFilterButtonClass }}"
                    (click)="mobileFilterHandler()"
                    *ngIf="statusTab === 1"
                >
                    <img
                        src="./assets/icons/actions/filter.svg"
                        alt="filter"
                        class="mobile-filter__button-swg"
                        *ngIf="!hasActiveFilters"
                    />
                    <img
                        src="./assets/icons/actions/filter-active.svg"
                        alt="filterAccepted"
                        class="mobile-filter__button-swg"
                        *ngIf="hasActiveFilters"
                    />
                </button>
            </div>
            <!-- [ngClass]="{ 'border-active': staticFilterSelected }" -->
        </div>
        <app-list-upcoming
            *ngIf="statusTab == 0 && isMobile"
            [rNumbs]="filteredRnumbList"
        ></app-list-upcoming>
        <app-list-completed
            *ngIf="statusTab == 1 && isMobile"
            [filterChecked]="filterChecked"
            (filterCheckedChange)="mobileFilterHandler($event)"
        ></app-list-completed>
    </div>
</div>

<div class="history-desktop">
    <div class="history-desktop__header">
        <span class="header__title">Мои посещения</span>
        <div class="header__tabs">
            <button
                class="cls-btn-rec-type"
                [ngClass]="{ 'active-type': statusTab == 0 }"
                (click)="changeTab(0)"
            >
                Предстоящие
            </button>
            <button
                class="cls-btn-rec-type"
                [ngClass]="{ 'active-type': statusTab == 1 }"
                (click)="changeTab(1)"
            >
                Завершенные
            </button>
            <button
                class="cls-btn-rec"
                *ngIf="isNotDate === false"
                routerLink="/home/rec"
            >
                Записаться к врачу
            </button>
        </div>
    </div>

    <div class="history-desktop__body">
        <app-panel class="app-panel">
            <div class="panel-container">
                <app-list-upcoming
                    *ngIf="statusTab == 0 && !isMobile"
                    (onDateGet)="dateGetMyRec($event)"
                    [selectDate]="sDate"
                    [rNumbs]="filteredRnumbList"
                ></app-list-upcoming>
                <app-list-completed
                    *ngIf="statusTab == 1 && !isMobile"
                    (onDateGet)="dateGet($event)"
                    [CountRecPage]="countRecToHeigh"
                ></app-list-completed>

            </div>
        </app-panel>
    </div>
</div>
